import { atom } from 'jotai';

const showDealerNumberAtom = atom<string>('');

export { showDealerNumberAtom };
